// pause in asynchronous functions
export const sleep = async (ms) =>
  new Promise((resolve) => setTimeout(resolve, ms))
